import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import GridContainer from '@/components/material-ui-kit/components/Grid/GridContainer';
import GridItem from '@/components/material-ui-kit/components/Grid/GridItem';
import styles from 'styles/jss/original/components/about/aboutIntroSection';

// @ts-expect-error
const useStyles = makeStyles(styles);

const text = {
  title: '狭いキッチンでつくる美しい食事習慣',
  description:
    'small dishは狭いキッチン向け献立メディア。\n「狭い」に特化した献立メディアだから本当に実践できる献立が見つかります。\nsmall dishでは「狭いキッチンでも作れる献立」「狭い空間で役立つアイデア集」\n「狭い空間でも活躍するアイテム紹介」などのコンテンツを掲載しています。\n一人暮らしを始めた方・料理初心者の方・ミニマリストの方など\n是非ご覧ください。'
};

const AboutIntroSection = () => {
  const classes = useStyles();

  return (
    <div className={classes.section}>
      <div className={classes.container}>
        {/* @ts-expect-error プロパティ「justify」は、タイプ「IntrinsicAttributes & Pick<InferProps<{ children.Requireable<ReactNodeLike>; className」に存在しません。*/}
        <GridContainer justify='center'>
          {/* @ts-expect-error */}
          <GridItem xs={12} sm={10} md={8}>
            <h3 className={classes.title}>{text.title}</h3>
            <h4 className={classes.description}>{text.description}</h4>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
};

export default AboutIntroSection;
